import { EntityType } from '@frontend/common';
import { IconType } from 'react-icons';
import {
    LuArrowLeftRight,
    LuBadgeCheck,
    LuBookDashed,
    LuBuilding,
    LuCalculator,
    LuCalendar,
    LuCalendarClock,
    LuCircleDot,
    LuClipboardCheck,
    LuCloudFog,
    LuCoins,
    LuCpu,
    LuDatabase,
    LuDoorOpen,
    LuFileInput,
    LuFileOutput,
    LuFlaskConical,
    LuFolder,
    LuHardDrive,
    LuHash,
    LuIdCard,
    LuLayers3,
    LuLayoutGrid,
    LuLayoutList,
    LuLayoutPanelLeft,
    LuLayoutTemplate,
    LuLockKeyholeOpen,
    LuLogs,
    LuMapPin,
    LuPackage,
    LuReceiptEuro,
    LuRibbon,
    LuSendToBack,
    LuShieldCheck,
    LuSquareSquare,
    LuSquareUserRound,
    LuTablet,
    LuTag,
    LuTriangleAlert,
    LuUser,
    LuWorkflow
} from 'react-icons/lu';

// Should be changed to SVG in the future
export const ENTITY_ICONS = {
    ACCOUNT: LuBuilding,
    ACCESS_LOG: LuDoorOpen,
    BADGE: LuIdCard,
    BASIC_AUTH: LuLockKeyholeOpen,
    BUDGET: LuCoins,
    CATEGORY: LuLayoutList,
    CERTIFICATE: LuShieldCheck,
    CHANGE: LuCloudFog,
    COLLI: LuPackage,
    CONTACT: LuSquareUserRound,
    CONTACT_GROUP: LuFolder,
    COST_CENTER: LuReceiptEuro,
    DECEASED: LuRibbon,
    DEVICE: LuTablet,
    EQUIPMENT: LuCpu,
    EQUIPMENT_GROUP: LuFolder,
    EVENT: LuCalendar,
    EXPORT: LuFileOutput,
    GROUP: LuFolder,
    IMPORT: LuFileInput,
    IMPORT_LOGS: LuLogs,
    INTEGRATION_TEST: LuFlaskConical,
    IOT: LuHardDrive,
    LICENSE: LuLayoutGrid,
    MODULE: LuLayoutPanelLeft,
    MOVEMENT: LuSendToBack,
    NOTIFICATION_TEMPLATE: LuLayoutTemplate,
    PACKAGE: LuArrowLeftRight,
    PRODUCT: LuTag,
    PRODUCT_CATEGORY: LuLayoutList,
    PRODUCT_GROUP: LuFolder,
    PROBLEM: LuTriangleAlert,
    RAKINDA: LuCalculator,
    REPORT: LuClipboardCheck,
    ROLE: LuBadgeCheck,
    SCHEDULE: LuCalendarClock,
    SEED: LuDatabase,
    SLOT: LuSquareSquare,
    SPOT: LuMapPin,
    STOCK: LuLayers3,
    TEMPLATE: LuBookDashed,
    TRANSACTION: LuHash,
    USER: LuUser,
    USER_GROUP: LuFolder,
    USER_INTERFACE: LuBookDashed,
    WORKFLOW: LuWorkflow
};

export function iconByType(type: EntityType): IconType {
    switch (type) {
        case EntityType.ACCOUNT:
            return ENTITY_ICONS.ACCOUNT;
        case EntityType.FUNCTIONALITY:
            return ENTITY_ICONS.LICENSE;
        case EntityType.WORKFLOW:
            return ENTITY_ICONS.WORKFLOW;
        case EntityType.PACKAGE:
            return ENTITY_ICONS.PACKAGE;
        case EntityType.TRANSACTION:
            return ENTITY_ICONS.TRANSACTION;
        case EntityType.USER:
            return ENTITY_ICONS.USER;
        case EntityType.DECEASED:
            return ENTITY_ICONS.DECEASED;
        case EntityType.DEVICE:
            return ENTITY_ICONS.DEVICE;
        case EntityType.IOT:
            return ENTITY_ICONS.IOT;
        case EntityType.RAKINDA:
            return ENTITY_ICONS.RAKINDA;
        case EntityType.NOTIFICATION_TEMPLATE:
            return ENTITY_ICONS.NOTIFICATION_TEMPLATE;
        case EntityType.BADGE:
            return ENTITY_ICONS.BADGE;
        case EntityType.STOCK:
            return ENTITY_ICONS.STOCK;
        case EntityType.SPOT:
            return ENTITY_ICONS.SPOT;
        case EntityType.MODULE:
            return ENTITY_ICONS.MODULE;
        case EntityType.SLOT:
            return ENTITY_ICONS.SLOT;
        case EntityType.TEMPLATE:
            return ENTITY_ICONS.TEMPLATE;
        case EntityType.PRODUCT:
            return ENTITY_ICONS.PRODUCT;
        case EntityType.USER_INTERFACE:
            return ENTITY_ICONS.USER_INTERFACE;
        case EntityType.SEED:
            return ENTITY_ICONS.SEED;
        case EntityType.INTEGRATION_TEST:
            return ENTITY_ICONS.INTEGRATION_TEST;
        case EntityType.CHANGE:
            return ENTITY_ICONS.CHANGE;
        case EntityType.EVENT:
            return ENTITY_ICONS.EVENT;
        case EntityType.BASIC_AUTH:
            return ENTITY_ICONS.BASIC_AUTH;
        case EntityType.MOVEMENT:
            return ENTITY_ICONS.MOVEMENT;
        case EntityType.CATEGORY:
            return ENTITY_ICONS.CATEGORY;
        case EntityType.ACCESS_LOG:
            return ENTITY_ICONS.ACCESS_LOG;
        case EntityType.CERTIFICATE:
            return ENTITY_ICONS.CERTIFICATE;
        case EntityType.COLLI:
            return ENTITY_ICONS.COLLI;
        case EntityType.COST_CENTER:
            return ENTITY_ICONS.COST_CENTER;
        case EntityType.BUDGET:
            return ENTITY_ICONS.BUDGET;
        case EntityType.EQUIPMENT:
            return ENTITY_ICONS.EQUIPMENT;
        case EntityType.PROBLEM:
            return ENTITY_ICONS.PROBLEM;
        case EntityType.ROLE:
            return ENTITY_ICONS.ROLE;
        case EntityType.PRODUCT_GROUP:
            return ENTITY_ICONS.PRODUCT_GROUP;
        case EntityType.EQUIPMENT_GROUP:
            return ENTITY_ICONS.EQUIPMENT_GROUP;
        case EntityType.USER_GROUP:
            return ENTITY_ICONS.USER_GROUP;
        case EntityType.PRODUCT_CATEGORY:
            return ENTITY_ICONS.PRODUCT_CATEGORY;
        case EntityType.REPORT:
            return ENTITY_ICONS.REPORT;
        case EntityType.SCHEDULE:
            return ENTITY_ICONS.SCHEDULE;
        case EntityType.FUNCTIONALITY:
            return ENTITY_ICONS.LICENSE;
        default:
            return LuCircleDot;
    }
}
